export default {
  facebook: "facebook",
  "google-oauth2": "google",
  apple: "apple",
};
